import DayBlock from "../DayBlock";

const WeekBlock = () => {
    return (
        <div className="weekBlock">
            <div className={`dayBlock`}>
                <DayBlock />
            </div>
            <div className={`dayBlock`}>
                <DayBlock />
            </div>
            <div className={`dayBlock`}>
                <DayBlock />
            </div>
            <div className={`dayBlock`}>
                <DayBlock />
            </div>
            <div className={`dayBlock`}>
                <DayBlock />
            </div>
            <div className={`dayBlock`}>
                <DayBlock />
            </div>
            <div className={`dayBlock`}>
                <DayBlock />
            </div>
        </div>
    );
};

export default WeekBlock;
